import { get } from 'lodash';

const base = 'VerificationSelectionState.selection';

export const getData = state => get(state, `${base}.data`);
export const getResult = state => get(state, `${base}.result`);
export const getLoading = state => get(state, `${base}.loading`);



// WEBPACK FOOTER //
// ./src/pages/verificationselection/state/selectors.js